import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, MoreVertical } from 'lucide-react';
export interface DropdownMenuItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  variant?: 'default' | 'danger';
}
export interface DropdownMenuProps {
  items: DropdownMenuItem[];
  className?: string;
  // Optional text trigger (e.g. "More actions") instead of the three-dot icon
  label?: string;
  'data-id'?: string;
}
export function DropdownMenu({
  items,
  className = '',
  label,
  'data-id': dataId
}: DropdownMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className={`relative inline-block ${className}`} ref={menuRef} data-id="element-5564" data-mp="1bd20at83x8xu">
      {label ? <button type="button" onClick={() => setIsOpen(!isOpen)} className="h-10 px-4 inline-flex items-center gap-2 rounded-md border border-[#CBD5E1] bg-white text-[14px] font-medium text-[#0F172A] hover:bg-[#F1F5F9] transition-all duration-200" aria-haspopup="menu" aria-expanded={isOpen} data-id="element-5565" data-mp="16dpca55i1vto">
          {label}
          <ChevronDown className={`h-4 w-4 text-[#64748B] transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-5566" data-mp="1u3jmsg2cj8ar" />
        </button> : <button onClick={() => setIsOpen(!isOpen)} className="h-12 w-12 flex items-center justify-center rounded-md border border-[#CBD5E1] hover:bg-[#F1F5F9] transition-all duration-200" aria-label="Open menu" aria-expanded={isOpen} data-id="element-5567" data-mp="1p4yq2qmaz6r2">
          <MoreVertical className="h-5 w-5 text-[#94A3B8]" data-id="element-5568" data-mp="1fc1b2ugirzx7" />
        </button>}

      {isOpen && <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-[0_4px_6px_rgba(15,23,42,0.1)] border border-[#CBD5E1] z-50" data-id="element-5569" data-mp="2cut070f8mh7m">
          {items.map((item, index) => <button key={index} onClick={() => {
        item.onClick();
        setIsOpen(false);
      }} style={{
        color: item.variant === 'danger' ? '#EF4444' : '#0F172A'
      }} className={`
                w-full px-4 py-3 text-left text-[14px] flex items-center gap-2
                ${item.variant === 'danger' ? 'hover:bg-[#FEF2F2]' : 'hover:bg-[#F1F5F9]'}
                ${index === 0 ? 'rounded-t-lg' : ''}
                ${index === items.length - 1 ? 'rounded-b-lg' : ''}
                transition-colors duration-200
              `} data-id="element-5570" data-mp="66aixrdrkc5u" data-mpi={index}>
              {item.icon && <span className="w-5 h-5 flex items-center justify-center" data-id="element-5571" data-mp="39mhl1tgj61ci">
                  {item.icon}
                </span>}
              {item.label}
            </button>)}
        </div>}
    </div>;
}